// Background subsection form field enum
export enum BackgroundFormField {
  BACKGROUND_PRIMARY_DIAGNOSIS = 'medical-background/background/primary-diagnosis',
  BACKGROUND_OTHER_DIAGNOSIS = 'medical-background/background/other-diagnosis',
  BACKGROUND_EQUIPMENT = 'medical-background/background/equipment',
  BACKGROUND_EQUIPMENT_OTHER = 'medical-background/background/equipment-other',
  BACKGROUND_DME_PROVIDER = 'medical-background/background/dme-provider',
  BACKGROUND_ALLERGIES = 'medical-background/background/allergies',
  BACKGROUND_ALLERGIES_NOTES = 'medical-background/background/allergies-notes',
  BACKGROUND_WAIVERS = 'medical-background/background/waivers',
  BACKGROUND_ADDITIONAL_SERVICES = 'medical-background/background/additional-services',
  BACKGROUND_PROGNOSIS = 'medical-background/background/prognosis',
  BACKGROUND_DNR = 'medical-background/background/dnr',
  BACKGROUND_ADVANCE_DIRECTIVES = 'medical-background/background/advance-directives',
  BACKGROUND_ADVANCE_DIRECTIVES_NOTES = 'medical-background/background/advance-directives-notes'
}
